// extracted by mini-css-extract-plugin
export var modal = "_bb-0";